"use client";

import { dynamicChart } from "@/components/charts/dynamicChart";

export type { RejectedCostProps } from "./RejectedCostChart.impl";

export const RejectedCostChart = dynamicChart(
  () => import("./RejectedCostChart.impl").then((m) => m.RejectedCostChart),
  300,
);
